import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CustomValidator,
  matchingPasswords,
} from 'src/app/_utlis/app-validators';
// Removed: getCurrentLngData, getPageData - migrated to ngx-translate
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';

import { environment } from 'src/environments/environment';
import { PasswordFormComponent } from '../../components/password-form/password-form.component';
import { BuyerAuthService } from '../../services/buyer-auth/buyer-auth.service';

@Component({
    selector: 'app-buyer-change-password',
        standalone: true,
imports: [
    ReactiveFormsModule,
    PasswordFormComponent,
    TranslatePipe
],
    templateUrl: './buyer-change-password.component.html',
    styleUrl: './buyer-change-password.component.scss'
})
export class BuyerChangePasswordComponent {
  formData!: FormGroup;
  code!: any;
  email?: string;
  submit_clicked = false;
  // defualtPath=DefulatRouting.DEFUALT;
  defualtPath = environment.wordpressUrl;
  urlFront!: string;
  userType!: string;navTranslation!: any;

  constructor(
    private fb: FormBuilder,
    private authBuyerService: BuyerAuthService,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private nav: Navigation,
    private analyticsService: AnalyticsService
  ) {
    this.initForm();
  }
  ngOnInit(): void {
    this.urlFront = environment.url_front;

  }
  initForm() {
    this.formData = this.fb.group(
      {
        current_password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            CustomValidator.patternValidator(/\d/, { hasNumber: true }),
            CustomValidator.patternValidator(/[a-zA-Z]/, { hasAlphabet: true }),
          ])
        ),
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            CustomValidator.patternValidator(/\d/, { hasNumber: true }),
            CustomValidator.patternValidator(/[a-zA-Z]/, { hasAlphabet: true }),
          ])
        ),
        password_confirmation: new FormControl(
          '',
          Validators.compose([Validators.required])
        ),
      },
      { validator: matchingPasswords('password', 'password_confirmation') }
    );
  }
  onPasswordFormChange(form: FormGroup): void {
    this.formData = form;
  }

  canSubmit(): boolean {
    return this.formData.valid;
  }
  onSubmit(formValues: any) {
    if (this.canSubmit()) {
      this.submit_clicked = true;
      let body = {
        ...formValues,
      };
      this.authBuyerService.changePassword(body).subscribe({
        next: (res) => {
          this.submit_clicked = false;
          this.toastService.showSuccess(res.message);
          // Track password changed
          // this.analyticsService.trackPasswordChange('buyer');

          setTimeout(() => {
            this.authService.logout();
            this.router.navigate(['/buyer/auth/login']);
          }, 1000);
        },
        error: (err) => {
          this.submit_clicked = false;
          this.toastService.showError(err.error.error[0]);
        },
      });
    }
  }
}
